import React, {Component} from 'react';
import T from 'i18n-react';
// Composants
import TextField from 'material-ui/TextField';

class MaterialFormInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
          touched: false
        };
    }

    /**
     * Lorsque l'input perd le focus
     * on met à jour le state de l'input
     */
    onBlur = () => this.setState({touched: true});

    render() {
        return (
            <TextField {...this.props}
                       errorText={this.state.touched ? T.translate(this.props.errorText) : ''}
                       onBlur={this.onBlur}
                       type={this.props.type ? this.props.type : ''}/>
        );
    }
}

export default MaterialFormInput;



// WEBPACK FOOTER //
// ./src/components/materialFormInput/MaterialFormInput.js